// extracted by mini-css-extract-plugin
export default {"container":"wX-z","title":"xX-z","link":"yX-z"};